import { defineMessages } from 'react-intl';

export default defineMessages({
  titleDatePickerPeriodo: {
    id: 'PeriodoFilterMesAnio.titleDatePicker',
    description: 'Label del componente picker para mes y año',
    defaultMessage: 'Periodo',
  },
});
